import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@xemplo/auth-provider';
import { CommonNavigate, CommonRoutes } from '@xemplo/common-routes';
import { tracker } from '@xemplo/tracking';
import { useAppSettings } from '@xemplo/xemplo-app-settings';

export function useConfirmLogin() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const { contextReturnUrlKey } = useAppSettings();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    let sessionUrl = sessionStorage.getItem(contextReturnUrlKey);
    if (sessionUrl?.includes(CommonRoutes.ConfirmLogin)) {
      sessionUrl = null;
    }

    const returnUrl = sessionUrl ?? CommonRoutes.Root;
    if (isAuthenticated) {
      tracker.setUserId(user?.profile?.sub);
      navigate(returnUrl, { replace: true });
      return;
    }
    tracker.reset();
    navigate(CommonNavigate.Login, { replace: true });
  }, [isLoading, isAuthenticated, navigate, contextReturnUrlKey, user]);
}
